import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Bitter cold and Neil Gaiman",
  "description": "",
  "published": "2009-01-12T00:00:00.000Z",
  "redirect_from": ["/blog/bitter-cold-and-neil-gaiman/swizec/19"],
  "categories": "blog, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I woke up into a somewhat warm room, but my bed was warmer. So I hit snooze, I can afford five more minutes. Then I hit snooze again. And again. And again. Ok so it's now been 30 minutes of snoozing in a warm bed. Fuck it, let's turn off the alarm, I can be warm for another 15 minutes right? Yes, of course, but it turned into 45 minutes instead. Oops. A quick shower and clothing later and I'm already on my way to work.`}</p>
    <p>{`Getting to work is a five minute walk for me. It was a cold morning, but a refreshing walk. I rather enjoyed it to be honest. But when I got to work something felt funny on my head, it was somewhat itchy and annoying. I go in to scratch it and ... lo and behold, my hair had frozen solid. What the fuck?`}</p>
    <p>{`But anyway, I've been reading `}<a parentName="p" {...{
        "href": "http://journal.neilgaiman.com/"
      }}>{`Neil Gaiman's Journal`}</a>{` lately and I like it so much that I want to become one of those Neil Gaiman readers, so I've decided to write him this question:`}</p>
    <p><em parentName="p">{`Dear Neil Gaiman,`}</em></p>
    <p><em parentName="p">{`I'm not a crazy fan and have until recently not even known you existed. That was, until I saw Amanda Palmer's webcam stream from a dinner with friends she did a while ago (I AM a crazy fan of hers, I admit). You seemed like a cool guy so I decided to check out your blog. This was the epiphany when I realised she doesn't say the Google You song was written by an "unknown gamer", but by "Neil Gaiman". Why those two sound so similar I don't know, probably because I'm not english.`}</em></p>
    <p><em parentName="p">{`Anyhow, I really like your blog and find it a delightful read. But seeming as how you write a lot more than just the blog and I'm becoming increasingly interested in reading your stuff, I was just wondering if you could make a recommendation on where to start? What would you say is your best work to reel in a new reader who has never had any contact with anything you've done?`}</em></p>
    <p>{`So yep, I'm just gonna go ahead and submit that through his "ask Neil Gaiman" thingy and hope for the best. Or can either of you readers suggest something?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      